export default __webpack_public_path__ + "static/media/redactSamplePdf.60111a78.png";